import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeBaseComponent } from 'src/app/_core';
import { ModalLoginComponent } from 'src/app/routes/auth/modals/modal-login/modal-login.component';
import { AccButtonComponent } from 'src/app/_shared/components/acc-button/acc-button.component';
import { IconComponent } from 'src/app/_shared/components/icon/icon.component';
import {
  CustomOverlayRef,
  CUSTOM_OVERLAY_DATA,
  OverlayService,
} from 'src/app/_core/services/overlay.service';

@Component({
  standalone: true,
  selector: 'neopos-modal-restore-password-summary',
  templateUrl: './modal-restore-password-summary.component.html',
  styles: [
    `
      :host {
        display: block;
        width: -webkit-fill-available;
        overflow: hidden;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, IconComponent, AccButtonComponent],
})
export class ModalRestorePasswordSummaryComponent extends ThemeBaseComponent {
  private readonly _dialogRef = inject(CustomOverlayRef);
  private readonly _data = inject(CUSTOM_OVERLAY_DATA);
  private readonly _overlayService = inject(OverlayService);

  loggedUser = this._data.loggedUser;

  onReturnToLogin(): void {
    this._dialogRef.close();

    if (!this._data.loggedUser) {
      this._overlayService.open(
        {
          width: 434,
          hasBackdrop: true,
          backdropClass: 'backdrop-style',
          responsive: true,
        },
        ModalLoginComponent
      );
    }
  }
}
